import * as cookie from 'cookie'

class CookieManager {
  get (name: string): string | undefined {
    const cookies = cookie.parse(document.cookie)
    return cookies[name]
  }

  set (name: string, value: string): void {
    document.cookie = cookie.serialize(name, value)
  }
}

export default CookieManager
